module.exports = __webpack_public_path__ + "static/assets/35178aa388d5f1ca49b5780a76b97995.png";